import type { ReactNode } from 'react';
import type {
  IAlertDialogProps,
  IConfirmationDialogProps,
} from './DialogEventManager';
import {
  DialogEvent,
  dialogEventManager,
  DialogTypes,
} from './DialogEventManager';

function generateDialogId() {
  return Math.random().toString(36).substring(2, 9);
}

export const dialog = {
  async confirm(
    content: ReactNode,
    options: Partial<IConfirmationDialogProps> = {},
  ) {
    const newDialogId = generateDialogId();

    dialogEventManager.emit(
      DialogEvent.Show,
      DialogTypes.Confirmation,
      content,
      {
        ...options,
        dialogId: options.dialogId || newDialogId,
      },
    );

    const promise = new Promise<boolean>(resolve => {
      dialogEventManager.on(DialogEvent.Close, (id, isAccepted) => {
        if (id === newDialogId) {
          resolve(isAccepted);
        }
      });
    });

    return promise;
  },

  async alert(content: ReactNode, options: Partial<IAlertDialogProps> = {}) {
    const newDialogId = generateDialogId();

    dialogEventManager.emit(DialogEvent.Show, DialogTypes.Alert, content, {
      ...options,
      dialogId: options.dialogId || newDialogId,
    });

    const promise = new Promise<boolean>(resolve => {
      dialogEventManager.on(DialogEvent.Close, (id, isAccepted) => {
        if (id === newDialogId) {
          resolve(isAccepted);
        }
      });
    });

    return promise;
  },
};
